import styles from '../styles.module.css';

const StorageFormSummaryItem = ({ index, title, selected, data, ...props }: any) => {
    return (
        <div className={`${styles.item} ${selected ? styles.selected : ''}`} {...props}>
            <span className={styles.index}>{index}</span>

            <span className={`h1 ${styles.header}`}>{title}</span>

            <div className={styles.lines}>
                {data?.lines?.map((line: any, index: number) => (
                    <span key={index} className={`h2 ${styles.subheader}`}>
                        {line}
                    </span>
                ))}
            </div>
            {!!data?.domicile && <span className={styles.domicile}>- {data.domicile} -</span>}
        </div>
    );
};

export default StorageFormSummaryItem;
